import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiResponse } from '../../../models/base';

const LIST_ENDPOINT = '/messaging';

@Injectable({
  providedIn: 'root',
})
export class MessagingService {
  private readonly http = inject(HttpClient);

  async send(data: any, type: string): Promise<any> {
    const response = await firstValueFrom(
      this.http.post<ApiResponse<any>>(environment.apiUrl + `${LIST_ENDPOINT}/${type}`, data)
    );

    return response.data;
  }
}